import { useEffect } from "react";
import { CalendarOutlined, MailOutlined, PhoneOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { globalAppInfo } from "../../config/globalAppInfo";
import "./PrivacyPolicy.css";

const RefundPolicy = () => {
  const lastUpdated = "February 19, 2026";

  useEffect(() => {
    // Scroll to top immediately on component mount
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
    <div className="legal-page">
      {/* Header */}
      <div className="legal-header">
        <div className="container">
          {/* <Link to="/" className="legal-back-link">
            <ArrowLeftOutlined /> Back to Home
          </Link> */}
          <div className="legal-header-icon">💳</div>
          <h1>Cancellation &amp; Refund Policy</h1>
          <p className="legal-subtitle">
            Please read our cancellation and refund terms before subscribing to our services.
          </p>
          <p className="legal-last-updated">
            <CalendarOutlined /> Last Updated: {lastUpdated}
          </p>
        </div>
      </div>

      {/* Single Document */}
      <div className="legal-content">
        <div className="container">
          <div className="legal-document">

            <p className="legal-intro">
              This Cancellation &amp; Refund Policy applies to all subscriptions and purchases made
              through <strong>{globalAppInfo.name}</strong> PLATFORM PRIVATE LIMITED. By subscribing to or
              purchasing any of our services, you acknowledge and agree to the terms outlined in this policy.
            </p>

            <h2>1. No Cancellation &amp; No Refund Policy</h2>

            <div className="legal-highlight">
              <strong>Important Notice:</strong> No cancellations and refunds are entertained once a
              subscription or purchase has been made. All sales are final.
            </div>

            <p>
              {globalAppInfo.name} operates a strict no-cancellation and no-refund policy for all
              subscription plans and one-time purchases. Once a payment has been processed and a
              subscription or service has been activated, we are unable to offer cancellations,
              refunds, or credits under any circumstances, unless otherwise required by applicable law.
            </p>

            <h2>2. Scope of This Policy</h2>
            <p>This policy applies to all products and services offered by {globalAppInfo.name}, including but not limited to:</p>
            <ul>
              <li>Monthly and annual subscription plans (Starter, Professional, Enterprise)</li>
              <li>WhatsApp Business API access and messaging credits</li>
              <li>Add-on features and integrations</li>
              <li>One-time setup or onboarding fees</li>
              <li>Any other paid services provided on the platform</li>
            </ul>

            <h2>3. Reasons This Policy Exists</h2>
            <p>
              Our no-refund policy reflects the nature of our digital services. Upon subscription
              activation, we immediately incur costs related to:
            </p>
            <ul>
              <li>WhatsApp Business API provisioning and Meta platform fees</li>
              <li>Account setup, configuration, and onboarding resources</li>
              <li>Server infrastructure and operational costs</li>
              <li>Team support and technical assistance allocated to your account</li>
            </ul>
            <p>
              These costs are incurred immediately upon your subscription and cannot be recovered
              after service commencement.
            </p>

            <h2>4. Free Trial</h2>
            <p>
              We strongly encourage all prospective users to take advantage of our free trial or demo
              session before committing to a paid plan. Our team is available to walk you through all
              features and answer any questions so you can make an informed decision prior to purchase.
            </p>

            <h2>5. Service Availability &amp; Exceptions</h2>
            <p>
              In the exceptional case where {globalAppInfo.name} is unable to deliver the subscribed
              service due to a technical failure or downtime on our end for a continuous period exceeding
              72 hours, we will work with the affected customer on a case-by-case basis to provide
              appropriate service credits or account extension. This is the only scenario in which any
              form of compensation may be considered, and it does not constitute a cash refund.
            </p>

            <h2>6. Subscription Renewal</h2>
            <p>
              Subscriptions are non-refundable and renew automatically based on the billing cycle you
              selected at the time of purchase. It is your responsibility to cancel auto-renewal (where
              applicable) before the next billing date if you do not wish to continue. Any charges
              already processed upon renewal are non-refundable.
            </p>

            <h2>7. Disputes &amp; Chargebacks</h2>
            <p>
              If you believe an unauthorized transaction has occurred on your account, please contact us
              immediately at <a href={`mailto:${globalAppInfo.email1}`}>{globalAppInfo.email1}</a> before
              initiating a chargeback with your payment provider. Initiating a chargeback without first
              contacting us may result in permanent suspension of your account and any associated services.
            </p>

            <h2>8. Changes to This Policy</h2>
            <p>
              {globalAppInfo.name} reserves the right to modify this Cancellation &amp; Refund Policy at
              any time. Any changes will be posted on this page with an updated revision date. Continued
              use of the platform after any changes constitutes your acceptance of the revised policy.
            </p>

            <h2>9. Contact Us</h2>
            <p>
              If you have any questions or concerns regarding this policy, please reach out to our
              support team. We are committed to addressing your queries promptly.
            </p>

            <div className="legal-contact-box">
              <p className="legal-contact-name">{globalAppInfo.name} PLATFORM PRIVATE LIMITED</p>
              <p><EnvironmentOutlined className="legal-contact-icon" />{globalAppInfo.addressline1}</p>
              <p><MailOutlined className="legal-contact-icon" />Email: <a href={`mailto:${globalAppInfo.email1}`}>{globalAppInfo.email1}</a></p>
              <p><PhoneOutlined className="legal-contact-icon" />Phone: {globalAppInfo.mobile1}</p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
